import { createStyles } from '@material-ui/core/styles';

const styles = (theme: any) => createStyles({
    alertIconError: {
        color: 'red',
    },
    alertIconWarning: {
        color: '#f99d1b',
    },
    alertIcon: {
        marginLeft: '5px',
        alignSelf: 'center'
    },
    infoIcon: {
        color: 'black',
        marginLeft: '5px',
        alignSelf: 'center',
        cursor: 'pointer'
    },
    link: {
        textDecoration: 'none'
    },
    hyperLink: {
        color: theme.palette?.hyperLink,
        textDecoration: 'underline',
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: 'block',
    },
    alertMessageDiv: {
        display: 'flex',

    },
    mainDiv: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    iconDiv: {
        display: 'flex',

    }
});

export default styles;
